<template>
    <div v-if="!$isGirlsAndSteam" class="containers" :class="{'containers_isef' : this.$isIsef, 'white-background' :  !this.$isIsef}" >
        <div :class="{'curved-background' : !this.$isIsef}"></div>
        <!-- Exist for ISEF only start-->
        <category-isef-mobile v-if="$isIsef" v-bind="{selectedCategoryID, userCategories, showSponsor}" />
        <router-link v-if="$isIsef" to="/home"
                     class="categories-sponsors-text"
                     :class="{'is-inactive' : !isHome}">
            <div class="categories-sponsors"
                 @click="() => {
                 clearFilter()
                 scrollToCategory()
               }">
                <img class="categories-sponsors-image"
                     :class="{'is-active' : isHome}"
                     src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ISEF2023%2Fcategories%2FAll%20Categories.png?alt=media&token=772a4ae1-cf08-475a-91fc-9227f2a8a197" alt="All Categories" />
                <p class="categories-sponsors-title">
                    All Categories
                </p>
            </div>
        </router-link>
        <!-- Exist for ISEF only end-->
        <ul class="categories is-mobile"
            :class="{'is-ios' : isIOS, 'is-centered' : inViewport, 'categories-isef' : $isIsef}"
            ref="categories"
            @scroll="scrollBlocks"
            qa="category-bubbles">
            <li v-for="(category, index) in categories"
                :key="category.id"
                class="category-container"
                :class="{
                  'is-inactive': selectedCategoryID > 0 && selectedCategoryID !== category.id && category.id !== parentCategoryID && category.id !== grandparentCategoryID,
                  'category-container-isef' : $isIsef
                }"
                :qa="category.name">
                <div v-if="!$isIsef" class="sponsor-container" :class="category.slug.toLowerCase()">
                    <div v-if="!$isEngCom"> <!-- no more sponsor images at the top on eng.com -->
                        <div v-if="(parentCategoryID === 0 || category.id === grandparentCategoryID) && !category.subCategories && $isEngCom" >
                            <!-- Render nothing if the category has no parent -->
                        </div>
                        <div v-else-if="category.sponsorLink !== ''">
                            <a :href="getUTMLink(category.sponsorLink, 'sponsor')" target="_blank" :aria-label="`Sponsored ad by ${category.sponsor}`"><img class="sponsor-image cursor-pointer is-flex" :class="{'max-height' : $isYSC}" :src="category.sponsorImage" :alt="category.sponsorImage"></a>
                        </div>
                        <div v-else>
                            <img class="sponsor-image is-flex" :class="{'max-height' : $isYSC}" :src="category.sponsorImage" :alt="category.sponsorImage">
                        </div>
                    </div>
                </div>
                <div class="category-image-container is-flex" v-bind="categoryTooltip(category, index)" @click="select(category)">
                    <div class="category-image-shadow" :class="{'category-image-shadow-isef' : $isIsef}">
                        <div class="category-image-circle"
                             :class="{
                              'category-image-circle-isef': $isIsef ,
                              'is-active': selectedCategoryID === category.id || category.id === parentCategoryID || category.id === grandparentCategoryID
                              }">
                            <img :class="'category-image cursor-pointer is-flex gtm-category-'+category.slug.toLowerCase()"
                                 :src="$isIsef ? category.image : proxyImage(category.image)" :alt="category.slug">
                        </div>
                    </div>
                    <category-star v-if="isLoggedIn && checkCategoryPreference(category)" :context="`big`"></category-star>
                </div>
                <div class="category-title" :class="{'category-title-isef' : $isIsef}">{{category.name}}</div>
                <!-- ISEF Sponsor show bottom -->
                <div v-if="$isIsef && category.sponsorImage"
                     class="sponsor-container-isef">
                    <a :href="category.sponsorLink" target="_blank">
                        <img class="sponsor-container-isef-image"
                             :src="category.sponsorImage"
                             :alt="category.sponsorImage">
                    </a>
                </div>
            </li>
        </ul>
        <div v-if="!isMobile && categories.length > 0"
             class="button-container">
            <div v-if="scrollLeft !== 0"
                 class="scroll-arrow cursor-pointer"
                 :class="{'sponsor': showSponsor, 'scroll-arrow-isef start-isef' : $isIsef ,'start' : !$isIsef}"
                 @mousedown="clickLeft"
                 @mouseout="stopScroll"
                 @mouseup="stopScroll"
                 @touchstart="clickLeft"
                 @touchend="stopScroll"
                 @touchcancel="stopScroll"
                 @keyup.enter="clickLeft"
                 aria-label="Scroll left"
                 tabindex="0">
                <i class="fal fa-chevron-left" aria-hidden="true"></i>
            </div>
            <div v-if="!inViewport"
                 class="end scroll-arrow cursor-pointer"
                 :class="{'sponsor': showSponsor , 'scroll-arrow-isef' : $isIsef}"
                 @mousedown="clickRight"
                 @mouseout="stopScroll"
                 @mouseup="stopScroll"
                 @touchstart="clickRight"
                 @touchend="stopScroll"
                 @touchcancel="stopScroll"
                 @keyup.enter="clickRight"
                 aria-label="Scroll right"
                 tabindex="0">
                <i class="fal fa-chevron-right" aria-hidden="true"></i>
            </div>
        </div>
    </div>
</template>

<script>
import CategoryStar from '@/components/Controls/CategoryStar'
import CategoryIsefMobile from './catgoriesIsefMobile'

import userAgent from '@/libs/user-agent'
import imageProxy from '@/libs/image-proxy'

import componentState from '@/mixins/component-state'
import auth from '@/mixins/auth'
import utmTracking from '@/mixins/utm-tracking'

export default {
  props: ['selectedCategoryID', 'userCategories', 'showSponsor'],
  mixins: [componentState, auth, utmTracking],
  components: { CategoryStar, CategoryIsefMobile },
  data: function () {
    return {
      scrollLeft: 0,
      interval: false,
      inViewport: true,
      categories: []
    }
  },
  watch: {
    categories: function () {
      this.$nextTick(() => this.checkIfInViewport())
    },
    categoriesLoaded: function () {
      this.loadCategories()
    },
    scrollLeft: function () {
      this.checkIfInViewport()
    },
    selectedCategoryID: function () {
      if (this.selectedCategoryID > 0) {
        this.scrollToCategory()
      }
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      // For YSC and OASAM i.e. single fair events, we need viewAll to default to show the categories for the fair
      // having home as the explore path.
      if (this.$isYSC || this.$isOasam) {
        this.$store.dispatch('setPage', 'home')
      }
      this.toggleListeners('add')
      this.checkIfInViewport()
      this.loadCategories()
      let selectedLanguage = localStorage.getItem('selectedLanguage')
      // If no language is selected, default to English
      if (!['en', 'fr'].includes(selectedLanguage)) {
        selectedLanguage = 'en'
      }
      // Dispatch action to update selected language in the Vuex store
      this.$store.dispatch('updateSelectedLanguage', selectedLanguage)
      // Dispatch action to fetch categories based on the stored language
      this.$store.dispatch('getCategories')
    })
  },
  destroyed: function () {
    this.toggleListeners('remove')
  },
  computed: {
    subEventParam: function () {
      if (this.$route.query.page) {
        return this.$route.query.page
      }
      return this.$route.path.substring(1)
    },
    categoriesLoaded: function () {
      return this.$store.getters.projectCategories
    },
    isHome: function () {
      return this.$route.name === 'home'
    },
    isIOS: function () {
      return userAgent.isIOS()
    },
    isMobile: function () {
      return userAgent.isAllMobile()
    },
    parentCategoryID: function () {
      return this.selectedCategoryID > 0 ? this.$store.getters.categoryByID(this.selectedCategoryID)?.parentID || this.selectedCategoryID : 0
    },
    grandparentCategoryID: function () {
      return this.parentCategoryID > 0 ? this.$store.getters.categoryByID(this.parentCategoryID)?.parentID || this.parentCategoryID : 0
    },
    userCategoriesIDs: function () {
      const userCatIDs = []
      if (this.userCategories) {
        for (let i = 0; i < this.userCategories.length; i++) {
          userCatIDs.push(this.userCategories[i].id)
        }
      }
      return userCatIDs
    },
    showStar: function () {
      return this.userCategoriesIDs.indexOf(this.category.id)
    }
  },
  methods: {
    clearFilter: function () {
      localStorage.removeItem('filterData')
      this.$root.$emit('clearAllFilters')
    },
    select: function (category) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'trackCategory',
          CategoryID: category.id,
          CategoryName: category.slug
        })
      }
      this.clearFilter()
      if (category.subCategories) {
        if (this.$route.params.category === category.slug) {
          this.$emit('viewCategory', category.name)
        } else {
          this.$router.push({ name: 'projectsCategory', params: { category: category.slug } })
        }
      } else {
        this.$router.push({ name: 'viewAll', query: { category: category.slug, page: this.subEventParam } }).catch(err => {
          // Ignore the vuex err regarding navigating to the current page.
          if (
            err.name !== 'NavigationDuplicated' &&
              !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            console.error(err)
          }
        })
      }
    },
    checkIfInViewport: function () {
      if (this.$refs.categories && this.$refs.categories.children.length > 0) {
        const bounding = this.$refs.categories.children[this.categories.length - 1].getBoundingClientRect()
        const rightSide = Math.min(document.documentElement.clientWidth, window.innerWidth)
        if (bounding.left >= 0 && bounding.right <= rightSide && bounding.bottom <= rightSide) {
          this.inViewport = true
        } else {
          this.inViewport = false
        }
      }
    },
    clickLeft: function () {
      if (!this.interval) {
        this.interval = setInterval(() => this.scrollLeftCat(), 10)
      }
    },
    clickRight: function () {
      if (!this.interval) {
        this.interval = setInterval(() => this.scrollRight(), 10)
      }
    },
    scrollRight: function () {
      if (!this.$refs.categories) {
        return
      }
      if (!this.$refs.categories.scrollLeft) {
        this.$refs.categories.scrollLeft = 0
      }
      if (!this.inViewport) {
        this.$refs.categories.scrollLeft += 20
        this.scrollLeft = this.$refs.categories.scrollLeft
        this.checkIfInViewport()
      }
    },
    scrollLeftCat: function () {
      if (!this.$refs.categories) {
        return
      }
      if (!this.$refs.categories.scrollLeft) {
        this.$refs.categories.scrollLeft = 0
        this.stopScroll()
      }
      this.$refs.categories.scrollLeft -= 20
      this.scrollLeft = this.$refs.categories.scrollLeft
      this.checkIfInViewport()
    },
    stopScroll: function () {
      clearInterval(this.interval)
      this.interval = false
    },
    scrollBlocks: function () {
      this.scrollLeft = this.$refs.categories.scrollLeft
    },
    proxyImage: function (src) {
      return imageProxy.category(src)
    },
    refreshKey: function () {
      return (Math.random() + 1).toString(36).substring(7)
    },
    toggleListeners: function (key) {
      window[`${key}EventListener`]('resize', this.checkIfInViewport)
    },
    checkCategoryPreference: function (category) {
      const catOrSubCat = category.subCategories || [category.id]
      const matches = this.userCategoriesIDs.filter(cat => catOrSubCat.includes(cat))
      return matches.length > 0
    },
    scrollToCategory: function () {
      setTimeout(() => {
        const selectAllCat = document.querySelector('a.categories-sponsors-text:not(.is-inactive)')
        let selectedCat = document.querySelector('ul.categories > .category-container:not(.is-inactive)')
        if (selectAllCat && this.isHome) {
          // Extra wait time for the page to load on home page
          setTimeout(() => {
            selectAllCat.scrollIntoView({
              behavior: 'smooth'
            })
          }, 1000)
        } else if (selectedCat && !this.isHome) {
          if (selectedCat.nextSibling) {
            selectedCat = selectedCat.nextSibling
          }
          selectedCat.scrollIntoView({
            behavior: 'smooth'
          })
        } else {
          // if failed to get selectedCategory, just scroll to top
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }, 1000)
    },
    categoryTooltip: function (category, index) {
      if (this.isMobile || category.description === '') {
        return
      }
      // change the tooltip position for the categories to fix description being cut off
      const pos = index < 4 ? 'up-left' : 'up-right'

      const tooltip = {}
      tooltip['data-balloon'] = category.description
      tooltip['data-balloon-pos'] = this.$isYSC ? pos : 'up'
      return tooltip
    },
    loadCategories: function () {
      const categories = this.$store.getters.categoriesLoaded ? this.$store.getters.projectCategories : []
      if (categories?.length > 0) {
        this.categories = categories.filter(category => !category.isPrivate)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.containers{
  padding: 1rem 0;
  position: relative;
  -ms-overflow-style: none;
  overflow-x: -moz-scrollbars-none;

  &_isef {
    display: flex;
    flex-direction: row;
    color: white;
  }

  &.white-background {
    background: var(--background-story-card);
  }
}
.curved-background {
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 60%;
  background: var(--background-fifth);
  border-top-left-radius: 100%;
  border-top-right-radius: 100%;
}
.is-inactive{
  opacity: 0.5;
}

.is-active {
  background: linear-gradient(132.76deg, #3E82B4 19.3%, #CC4B79 36.86%, #DF8E44 59.91%, #FFD563 80.24%);
}

::-webkit-scrollbar {
  display: none;
  background: transparent;
}
.categories {
  margin-left: 1.3rem;
  margin-right: 1.3rem;
  padding-top: 1rem;
  overflow: hidden;
  display: flex;
  position: relative;
  overflow-x: auto;
  &-sponsors {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 8rem;
    margin-left: 3rem;
    @include mobile{
      margin-left: .5rem;
    }
    &-image {
      margin: 2.15rem 0 1.2rem 0;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      @include mobile{
        margin-top: 1.9rem !important;
        margin-bottom: .5rem !important;
      }
    }
    &-text {
      margin-top: 0 !important;
      height: 40px;
      font-family: "Helvetica Neue", serif;
      font-style: normal;
      font-weight: 500;
      font-size: 0.9em;
      text-align: center;
      letter-spacing: -0.02em;
      color: #FFFFFF;
      @media only screen and (max-width: 550px) {
        display: none;
      }
    }
  }
  &-isef {
    position: relative;
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;
    @media only screen and (max-width: 550px) {
      display: none;
    }
  }
  &.is-centered {
    @media only screen {
      justify-content: center;
    }
  }
  @include tablet-only{
    margin-right: 1.3rem;
  }
  @include mobile{
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-bottom: 0.5rem;
  }
  @include fix-ios-scrolling;

  .category-container{
    width: 9rem;
    min-width: 8rem;
    text-align: center;
    justify-content: flex-end;
    align-items: flex-end;
    &-isef {
      min-width: 9rem;
    }
    @include mobile{
      width: 7.3rem;
      min-width: 7.3rem;
    }
    .category-image-container{
      justify-content: flex-end;
      align-items: flex-end;
      margin: 0 auto;
      position: relative;
    }
    // Needed a separate div for the shadow and one for the cropped circle specifically for Safari
    .category-image-shadow {
      position: relative;
      height: 7.5rem;
      width: 7.5rem;
      box-shadow: $default-shadow;
      border-radius: 50%;
      margin: 0 auto;
      overflow: hidden;
      &-isef {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      @include mobile{
        height: 6.5rem;
        width: 6.5rem;
      }
    }
    .category-image-circle {
      width: 100%;
      height: 100%;
      clip-path: circle(50% at 50% 50%);
      &:hover,
      &:focus,
      &:active {
        img {
          transform: scale(1.1);
          @include touch {
            transform: none;
          }
        }
      }
      &-isef {
        width: 80px;
        height: 80px;
      }
    }
    .category-image{
      max-width: 100%;
      transition: all 0.2s;
    }
    .sponsor-container {
      display: flex;
      align-items: center;
      margin: 0.5rem auto;
      height: 40px;
      max-width: 94%;
      &.how-to,
      &.digital-fabrication {
        max-width: 90px;
      }
      &.technology {
        max-width: 110px;
      }
      &.craft-and-design,
      &.home-diy {
        max-width: 120px;
      }
      &.home-de {
        max-width: 60%;
      }
    }
    .sponsor-image {
      margin: 0 auto;
    }
    .max-height {
      max-height: 100%;
    }
    .category-title{
      word-wrap: break-word;
      color: var(--font-colour);
      line-height: 1.3;
      font-size: 0.8rem;
      font-weight: 400;
      margin-top: 0.75rem;
      padding: 0 0.5rem;
      @include mobile {
        font-size: 0.7rem;
      }
      &-isef {
        margin-top: 0 !important;
        height: 45px;
        font-family: 'Helvetica Neue';
        font-style: normal;
        font-weight: 500;
        font-size: .8em;
        text-align: center;
        letter-spacing: -0.02em;
        color: #FFFFFF;
      }
    }
  }
}

.categories.is-ios {
  overflow-x: scroll;
  margin-left: 0;
  padding-left: 0;
}

.column {
  padding: 0.4rem;
}

.button-container {
  position: absolute;
  top: 1.25rem;
  left: 0;
  right: 0;

  .scroll-arrow {
    height: 7.5rem;
    position: absolute;
    top: 4.2rem;
    background: black;
    opacity: 0.7;
    padding: 0.6rem 0.4rem;
    display:flex;
    align-items: center;
    i {
      color: #fff;
    }
    &-isef {
      display: flex;
      justify-content: center;
      opacity: 1 !important;
      width: 56px !important;
      height: 72px !important;
      margin: -2.5rem .5rem 0 .5rem;
      background: rgba(255, 255, 255, 0.12) !important;
      border: 1px solid rgba(255, 255, 255, 0.6);
      backdrop-filter: blur(24px);
      border-radius: 12px;
    }
  }

  .start {
    left: 1.3rem;
    &-isef {
      left: 12rem;
      @include mobile {
        left: 10rem;
      }
    }
  }

  .end {
    right: 1.3rem;
  }

  .sponsor {
    height: 7.5rem;
    top: 4.2rem;
  }
}

.sponsor-container-isef {
  margin: 1rem .4rem;
  display: flex;
  justify-content: center;
  align-content: center;
  background-color: white;
  max-height: 42px;
  &-image {
    object-fit: contain;
    max-height: 39px;
    padding: 2px;
  }
}

@include mobile {
  .button-container {
    .scroll-arrow:not(.sponsor) {
      height: 7rem;
    }
    .start {
      left: 0;
    }
    .end {
      right: 0;
    }
    .sponsor {
      height: 6.5rem;
    }
    .category-container {
      .sponsor-image {
        max-height: 35px;
      }
    }
  }
}
</style>
